<template>
    <div class="af-apply-resume afu-bg-white">
        <ValidationProvider
            name="Resume"
            rules="required"
        >
            <!-- <ul v-if="!$_job.is_resume_mandatory">
                <li>
                    <a
                        href=""
                        @click.prevent.stop="applyWithoutResume()"
                    >
                        {{ applyWithoutResumeText }}
                    </a>
                </li>
            </ul> -->
            <div class="af-apply-resume-uploader afu-flex afu-flex-col md:afu-flex-row">
                <div class="af-apply-resume-file afu-bg-neutral-light afu-w-full md:afu-w-2/5 afu-border-r afu-border-solid afu-border-b-0 afu-border-t-0 afu-border-l-0 afu-border-neutral">
                    <div class="afu-p-5 md:afu-p-6">
                        <!-- v-show="!loader.store_resume" -->
                        <div
                            href="javascript:void(0)"
                            id="dropzone-uploader-wrap"
                            class="afu-text-primary afu-w-full afu-border afu-bg-white afu-x-4 afu-py-0 afu-h-150 afu-flex afu-items-center afu-justify-center afu-text-center afu-cursor-pointer afu-relative"
                            :class="{'afu-border-danger afu-border-solid': uploadState.state == 'error', 'afu-border-dashed afu-border-neutral hover:afu-border-secondary': uploadState.state == '', 'afu-border-success-400 afu-border-solid': uploadState.state == 'success',}"
                        >
                            <VueDropzone
                                ref="dropzoneResume"
                                id="dropResume1"
                                class="afu-flex afu-justify-center afu-items-center afu-flex-col afu-h-full afu-w-full"
                                :options="dropOptions"
                                @vdropzone-file-added="handleUploadedResume"
                                @vdropzone-error="getDropzoneError"
                                :use-custom-slot="true"
                            >
                                <Transition
                                    name="fade"
                                    mode="out-in"
                                >
                                    <div
                                        v-if="uploadState.state == ''"
                                        class="dropzone-custom-content afu-text-center afu-text-sm afu-text-secondary"
                                    >
                                        <C1Spinner
                                            v-if="loader.store_resume"
                                            variant="af"
                                            small
                                        />
                                        <div v-else>
                                            <div
                                                class="dropzone-custom-title afu-text-xl afu-font-semibold afu-mb-2"
                                                v-html="$t('resume.drag_and_drop_info')"
                                            />
                                            <div class="af-resume-file-size subtitle afu-text-neutral-dark afu-text-base">
                                                {{ $t('resume.file_type_info') }}
                                            </div>
                                        </div>
                                    </div>
                                </Transition>
                                <Transition
                                    name="fade"
                                    mode="out-in"
                                >
                                    <div
                                        v-if="uploadState.state == 'error'"
                                    >
                                        <svg 
                                            width="20" 
                                            height="18" 
                                            viewBox="0 0 20 18" 
                                            fill="none" 
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="afu-mb-2"
                                        >
                                            <path 
                                                d="M19.7749 15.2782C20.4158 16.3891 19.6113 17.7778 18.3313 17.7778H1.66855C0.386017 17.7778 -0.414747 16.387 0.224906 15.2782L8.55637 0.832813C9.19758 -0.278611 10.8036 -0.276597 11.4437 0.832813L19.7749 15.2782ZM10 12.2917C9.11789 12.2917 8.40279 13.0068 8.40279 13.8889C8.40279 14.771 9.11789 15.4861 10 15.4861C10.8821 15.4861 11.5972 14.771 11.5972 13.8889C11.5972 13.0068 10.8821 12.2917 10 12.2917ZM8.48359 6.55049L8.74116 11.2727C8.7532 11.4937 8.93591 11.6667 9.1572 11.6667H10.8428C11.0641 11.6667 11.2468 11.4937 11.2589 11.2727L11.5164 6.55049C11.5295 6.31181 11.3394 6.11111 11.1004 6.11111H8.89959C8.66057 6.11111 8.47057 6.31181 8.48359 6.55049Z" 
                                                fill="#F95157"
                                            />
                                        </svg>
                                        <div class="afu-mb-2 afu-text-black afu-text-lg afu-font-semibold">
                                            {{ uploadState.filename }}
                                        </div>
                                        <div class="afu-text-base">
                                            {{ uploadState.message }}
                                        </div>
                                    </div>
                                </Transition>
                                <Transition
                                    name="fade"
                                    mode="out-in"
                                >
                                    <div
                                        v-if="uploadState.state == 'success'"
                                    >
                                        <svg 
                                            width="20" 
                                            height="20" 
                                            viewBox="0 0 20 20" 
                                            fill="none" 
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="afu-mb-2"
                                        >
                                            <path 
                                                d="M20 10C20 15.5229 15.5229 20 10 20C4.47714 20 0 15.5229 0 10C0 4.47714 4.47714 0 10 0C15.5229 0 20 4.47714 20 10ZM8.84331 15.2949L16.2627 7.87556C16.5146 7.62363 16.5146 7.21512 16.2627 6.96319L15.3503 6.05081C15.0983 5.79883 14.6898 5.79883 14.4379 6.05081L8.3871 12.1015L5.56214 9.27657C5.3102 9.02464 4.90169 9.02464 4.64972 9.27657L3.73734 10.189C3.4854 10.4409 3.4854 10.8494 3.73734 11.1013L7.93089 15.2949C8.18286 15.5469 8.59133 15.5469 8.84331 15.2949Z" 
                                                fill="#0ACF83"
                                            />
                                        </svg>

                                        <div class="afu-mb-2 afu-text-black afu-text-lg afu-font-semibold">
                                            {{ uploadState.filename }}
                                        </div>
                                        <div class="afu-text-base afu-text-neutral-dark">
                                            {{ $t('resume.ducment_uploaded') }}
                                        </div>
                                    </div>
                                </Transition>
                            </VueDropzone>
                        </div>
                        <div class="afu-text-black afu-font-semibold afu-text-base afu-w-full afu-flex afu-items-center afu-justify-start afu-py-5 af-file-picker-wrapper afu-border afu-border-b-1 afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-neutral afu-border-solid">
                            <img
                                :src="getDropboxLogo"
                                class="afu-mr-2"
                                alt="Dropbox"
                            >
                            <DropboxPicker
                                class="afu-cursor-pointer afu-text-sm"
                                @picked="onDropboxPicked"
                            />
                        </div>
                        <div class="afu-text-black afu-font-semibold afu-text-base afu-w-full afu-flex afu-items-center afu-justify-start afu-pt-4 afu-pb-0 md:afu-py-4 af-file-picker-wrapper afu-border afu-border-b-0 md:afu-border-b-1 afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-neutral afu-border-solid afu-hidden">
                            <img
                                :src="getGoogleDriveLogo"
                                class="afu-mr-2"
                                alt="Google Drive"
                            >
                            <GoogleDrivePicker
                                class="afu-cursor-pointer afu-text-sm"
                                @gdPicked="onGoogleDrivePicked"
                            />
                        </div>
                    </div>
                </div>
                <div class="af-resumes afu-w-full md:afu-w-3/5 afu-border afu-border-b-0 afu-border-t md:afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-neutral afu-border-solid">
                    <template v-if="!$_me.id && resumeFile.name">
                        <ul class="af-resume-list afu-list-none afu-m-0 afu-px-5 afu-py-7 md:afu-px-10 md:afu-py-4">
                            <li class="afu-flex afu-flex-row afu-items-start afu-mb-4 last:afu-mb-0 afu-text-sm">
                                <a
                                    href=""
                                    @click.stop.prevent="removeResumeFile()"
                                    class="afu-text-base afu-font-semibold afu-text-black afu-mb-2 afu-no-underline"
                                >
                                    <FontAwesomeIcon
                                        :icon="['far', 'trash-alt']"
                                        class="afu-mr-2 afu-w-2"
                                    />
                                </a>
                                <span>{{ resumeFile.name }}</span>
                            </li>
                        </ul>
                    </template>
                    <template v-if="!$_me.id && $_guestResume.uuid && !resumeFile.name">
                        <ul class="af-resume-list afu-list-none afu-m-0 afu-px-10 afu-py-4 first:afu-pt-0">
                            <li class="afu-flex afu-flex-col afu-flex-wrap afu-items-start afu-pb-5 afu-border-b afu-border-t-0 afu-border-l-0 afu-border-r-0 afu-border afu-border-solid afu-border-neutral">
                                <span class="afu-text-base afu-font-semibold afu-text-black afu-mb-2">{{ $_guestResume.file_name }}</span>
                                <!-- <a
                                    href="#"
                                    @click.prevent.stop="downloadResume($_guestResume)"
                                    class="af-btn af-download-resume afu-my-2 afu-py-1 afu-px-4 afu-text-center afu-text-xs afu-text-gray-900 afu-bg-white afu-border afu-border-solid afu-border-gray-400 afu-rounded hover:afu-no-underline"
                                >
                                    {{ $t('label.download') }}
                                </a> -->
                                <C1Button
                                    class="afu-mt-3"
                                    size="sm"
                                    @click.prevent.stop="downloadResume($_guestResume)"
                                    variant="neutral"
                                >
                                    {{ $t('label.download') }}
                                </C1Button>
                            </li>
                        </ul>
                    </template>
                    <template v-if="$_me.id && resumes.length">
                        <div class="af-uploaded-resumes afu-text-neutral-dark afu-uppercase afu-font-semibold afu-text-5xl afu-pt-5 afu-px-7 afu-tracking-widest afu-mb-4">
                            {{ $t('resume.uploaded_resumes') }}
                        </div>
                        <ul class="af-resume-list afu-list-none afu-m-0 afu-px-8 afu-py-4 md:afu-py-1">
                            <li
                                v-for="(resume, index) in resumes"
                                :key="`resume_${resume.id}_${index}`"
                                class="afu-flex afu-flex-row afu-items-start afu-py-5 first:afu-pt-0 last:afu-border-none afu-border-b afu-border-t-0 afu-border-l-0 afu-border-r-0 afu-border afu-border-solid afu-border-neutral afu-flex-wrap"
                            >
                                <div class="af-resume-list-left afu-mr-5 afu-mt-2">
                                    <FontAwesomeIcon
                                        v-if="selectedResume.id === resume.id"
                                        :icon="['far', 'dot-circle']"
                                        class="afu-mr-2 afu-w-3 afu-text-primary"
                                    />
                                    <FontAwesomeIcon
                                        v-else
                                        :icon="['far', 'circle']"
                                        @click.stop.prevent="selectResume(resume)"
                                        class="afu-mr-2 afu-w-3"
                                    />
                                </div>
                                <div class="af-resume-list-right afu-flex afu-flex-col afu-flex-wrap afu-items-start afu-flex-1">
                                    <a
                                        href="#"
                                        class="afu-text-base afu-font-semibold afu-text-black afu-mb-2"
                                        @click.stop.prevent="selectResume(resume)"
                                    >
                                        {{ resume.file_name }}
                                    </a>
                                    <span class="af-resume-date afu-text-base afu-text-neutral-dark">
                                        <span class="af-uploaded-date">Uploaded {{ resume.created_at | dateFormat(' DD MMM YYYY') }}</span>
                                        <span
                                            v-if="resume.is_default"
                                            class="af-default-resume afu-text-success-400 afu-text-base"
                                        >
                                            <FontAwesomeIcon
                                                :icon="['fas', 'circle']"
                                                size="xs"
                                                class="afu-mr-1 afu-ml-2 afu-w-1 afu-h-1"
                                            />
                                            {{ $t('resume.default') }}
                                        </span>

                                    </span>
                                    <C1Button
                                        class="afu-mt-3"
                                        size="sm"
                                        @click.prevent.stop="downloadResume(resume)"
                                        variant="neutral"
                                    >
                                        {{ $t('label.download') }}
                                    </C1Button>
                                    <div
                                        v-if="selectedResume.id && !selectedResume.is_default && selectedResume.id === resume.id"
                                        class="afu-cursor-pointer afu-border afu-border-solid afu-border-neutral afu-py-2 afu-px-4 afu-bg-neutral-light afu-mt-4 afu-self-stretch"
                                        @click="onResumeDefaultClick()"
                                    >
                                        <div class="afu-flex afu-items-center afu-text-xs">
                                            <FontAwesomeIcon
                                                v-if="makeResumeDefault"
                                                :icon="['far', 'check-square']"
                                                class="afu-mr-2 afu-w-3"
                                            />
                                            <FontAwesomeIcon
                                                v-else
                                                :icon="['far', 'square']"
                                                class="afu-mr-2 afu-w-4"
                                            />
                                            <span
                                                class="afu-text-secondary afu-text-base afu-font-semibold"
                                            >
                                                {{ $t('resume.default_option') }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                </div>
                <input
                    v-model="isResumeFieldValid"
                    type="hidden"
                    name="resume"
                >
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
    import has  from 'lodash/has';
    import { Bus } from '@/utils/bus';
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
    import Filters from '@/components/Utils/Filters';
    import { ValidationProvider } from 'vee-validate';
    import VueDropzone from 'vue2-dropzone';
    // import C1HelpText from '@/components/C1Components/C1HelpText';
    import C1Spinner from '@/components/C1Components/C1Spinner';
    import { downloadFileFromUrl } from '@/utils/helpers';
    import GoogleDrivePicker from './GoogleDrivePicker';
    import DropboxPicker from './DropboxPicker';
    // import C1Alert from '@/components/C1Components/C1Alert';
    import C1Button from '@/components/C1Components/C1Button';
    import ApplyMixin from './ApplyMixin';

    export default {
        name: 'ApplyResume',

        components: {
            ValidationProvider,
            C1Spinner,
            VueDropzone,
            DropboxPicker,
            GoogleDrivePicker,
            C1Button,
        },

        mixins: [Filters, ApplyMixin],

        // props: {
        //     uploadState: {
        //         type: Boolean,
        //         default: false,
        //     },
        // },

        data() {
            return {
                maxFilesize: 10000000,
                selectedResume: {},
                resumes: [],
                applyWithoutResumeText: this.$t('resume.apply_without'),
                applyNoResume: false,
                showResumeReview: false,
                response: {
                    status: '',
                    message: '',
                },
                loader: {
                    get_resumes: false,
                    store_resume: false,
                },
                dropOptions: {
                    url: '/',
                    maxFiles: null,
                    addRemoveLinks: false,
                    uploadMultiple: false,
                    maxFilesize: 10,
                    autoProcessQueue: false,
                    acceptedFiles: '.pdf,.doc,.docx,.rtf,.txt,.odt,.pages',
                    createImageThumbnails: false,
                    includeStyling: false,
                },
                dropErrorMessage: '',
                uploadState: {
                    state: '',
                    filename: '',
                    message: '',
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
                $_guestResume: state => state.me.guestResume,
            }),

            ...mapGetters('jobApplication', {
                $_applyEmail: 'applyEmail',
                $_isApplyAsNewUser: 'isApplyAsNewUser',
            }),

            defaultText() {
                if (has(this.selectedResume, 'file_name') || has(this.selectedResume, 'filename')) {
                    return this.selectedResume.file_name || this.selectedResume.filename;
                }

                if (this.applyNoResume) {
                    return this.applyWithoutResumeText;
                }

                return this.$t('resume.default_text');
            },

            resumeFile() {
                return this.selectedResume instanceof File ? this.selectedResume : '';
            },

            isResumeFieldValid() {
                const isResumeAttachmentOpt = this.isResumeAttachmentOptional();
                if (this.selectedResume.id || this.resumeFile.name || isResumeAttachmentOpt) {
                    return true;
                }

                if (this.defaultText === this.applyWithoutResumeText) {
                    return true;
                }

                return '';
            },

            makeResumeDefault: {
                get() {
                    return this.$_jobApplication.make_resume_default;
                },

                set(value) {
                    value ? this.$_CHECK_RESUME_DEFAULT() : this.$_UNCHECK_RESUME_DEFAULT();
                },
            },

            getDropboxLogo() {
                return `${process.env.VUE_APP_URL}${require('@/assets/img/dropbox.svg')}`;
            },

            getGoogleDriveLogo() {
                return `${process.env.VUE_APP_URL}${require('@/assets/img/google-drive.svg')}`;
            },
        },

        watch: {
            selectedResume: {
                handler(resume) {
                    this.$emit('resumeSelected', resume);
                },
                deep: true,
            },
        },

        created() {
            Bus.$on('reloadResumes', () => {
                this.getResumes();
            });

            if (this.$_me.id) {
                this.getResumes();
            } else if(this.$_guestResume) {
                this.selectResume(this.$_guestResume);
            }
        },

        mounted() {
        },

        methods: {
            ...mapActions('me', {
                $_storeResume: 'storeResume',
                $_getResume: 'getResume',
                $_downloadResume: 'downloadResume',
                $_saveResumeFromUrl: 'saveResumeFromUrl',
                $_createGuestResume: 'createGuestResume',
            }),


            ...mapMutations('jobApplication', {
                $_CHECK_RESUME_DEFAULT: 'CHECK_RESUME_DEFAULT',
                $_UNCHECK_RESUME_DEFAULT: 'UNCHECK_RESUME_DEFAULT',
            }),

            ...mapMutations('me', {
                $_STORE_GUEST_RESUME: 'STORE_GUEST_RESUME',
            }),

            getResumes() {
                this.loader.get_resumes = true;
                this.$_getResume().then((response) => {
                    this.resumes = response.data;
                    this.resumes.map((r) => {
                        if (r.is_default){
                            this.selectResume(r);
                        }
                    });
                }).finally(() => {
                    this.loader.get_resumes = false;
                });
            },

            storeResume(file) {
                if (this.$_me.id) {
                    this.loader.store_resume = true;
                    this.$_storeResume(file).then((response) => {
                        this.resumes.map((r) => {
                            if(r.is_default){
                                this.$set(r, 'is_default', false);
                            }
                        });
                        this.resumes.unshift(response.data);
                        this.selectResume(response.data);
                        this.uploadState.state = 'success';
                        this.uploadState.filename = file.name;
                        setTimeout(() => { this.uploadState.state = ''; }, 3000);
                    }).finally(() => {
                        this.loader.store_resume = false;
                    });
                } else {
                    this.selectResume(file);
                }
            },

            selectResume(resume) {
                this.selectedResume = resume;
            },

            applyWithoutResume() {
                this.removeResumeFile();
                this.applyNoResume = true;
            },

            removeResumeFile() {
                this.selectedResume = this.$_guestResume;
            },

            onResumeDefaultClick() {
                this.makeResumeDefault = !this.makeResumeDefault;
            },

            downloadResume(resume) {
                this.$_downloadResume(resume.uuid).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.headers['resume-filename']);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            },

            async onDropboxPicked(files) {
                if (Array.isArray(files) && files.length > 0) {
                    const response = await downloadFileFromUrl(files[0].link);
                    const resume = new File(
                        [response.data],
                        files[0].name,
                        {
                            type: response.data.type,
                            lastModified: Date.now(),
                        },
                    );

                    this.handleUploadedResume(resume);
                }
            },

            async onGoogleDrivePicked(file) {
                this.response.status = '';
                this.response.message = '';

                let file_name = file.name;

                if(file.name.split('.').length > 1){
                    file_name = file.name.split('.')[0];
                }

                if (!['docx', 'doc', 'pdf'].includes(file.extension)){
                    // this.response.status = 'danger';
                    // this.response.message = this.$t('resume.file_type_info');
                    this.uploadState.state = 'error';
                    this.uploadState.filename = file_name;
                    this.uploadState.message = this.$t('resume.file_type_info');

                    return;
                }

                if (file.sizeBytes > this.maxFilesize){
                    // this.response.status = 'danger';
                    // this.response.message = this.$t('resume.max_resume_size_info');
                    this.uploadState.state = 'error';
                    this.uploadState.filename = file_name;
                    this.uploadState.message = this.$t('resume.max_resume_size_info');
                    return;
                }

                file_name = file_name + '.' + file.extension;
                const response = await downloadFileFromUrl(file.link, file.access_token);
                if (response.data) {
                    const resume = new File(
                        [response.data],
                        file_name,
                        {
                            type: response.data.type,
                            lastModified: Date.now(),
                        },
                    );
                    this.handleUploadedResume(resume);
                }
            },

            handleUploadedResume(resume) {
                this.dropErrorMessage = '';
                if (this.$_me.id) {
                    this.storeResume(resume);
                } else {
                    if (this.$_isApplyAsNewUser) {
                        this.resumes.map((r) => {
                            if(r.is_default){
                                this.$set(r, 'is_default', false);
                            }
                        });
                        this.selectResume(resume);
                    } else {
                        const formData = new FormData();
                        formData.append('resume_file', resume);
                        formData.append('email', this.$_applyEmail);
                        formData.append('recaptcha_disable', true);

                        this.$_createGuestResume(formData).then((response) => {
                            this.resumes.map((r) => {
                                if(r.is_default){
                                    this.$set(r, 'is_default', false);
                                }
                            });
                            this.$_STORE_GUEST_RESUME(response.data);
                            this.selectResume(response.data);
                        });
                    }
                }
            },

            getDropzoneError(file, message) {
                console.log(file);
                if (message) {
                    this.dropErrorMessage = message;
                    this.uploadState.state = 'error';
                    this.uploadState.filename = file.name;
                    this.uploadState.message = message;
                }
            },
        },
    };
</script>

<style>
    .dz-preview,
    .dz-file-preview {
        display: none;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .fade-enter,
    .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
